import Component from '@glimmer/component'
import { service } from '@ember/service'
import SideNavItem from 'teacher-ui-client/components/side-nav/item'
import SideNavIconComponent from 'teacher-ui-client/components/side-nav/icon'
import { t } from 'ember-intl'
import type FeatureControlService from 'teacher-ui-client/services/feature-control'
import { FeatureAccess } from 'teacher-ui-client/services/feature-control'

export class QuickStartLink extends Component<unknown> {
  @service featureControl!: FeatureControlService

  get isVisible() {
    return this.featureControl.canAccess(FeatureAccess.QuickStart)
  }

  <template>
    {{#if this.isVisible}}
      <SideNavItem data-test-side-nav-quick-start @linkTo="subscription-type.quick-start">
        <SideNavIconComponent @phosphorIcon="phosphor-shooting-star-fill" />
        <span> {{t "quickStart"}}</span>
      </SideNavItem>
    {{/if}}
  </template>
}

export default QuickStartLink
